import { CountryCode, NumberFormat, parsePhoneNumber } from "libphonenumber-js";
import { IntlShape, useIntl } from "react-intl";
import { ExpandedFormats } from "@sinch/core/hooks/format.types";
import { useSettings } from "@sinch/core/providers/AppSettings";

export const useFormatPhone = () => {
  const { country } = useSettings();
  const { formats } = useIntl() as IntlShape & {
    formats: ExpandedFormats;
  };
  return (value: string, { format }: { format?: keyof ExpandedFormats["phone"] }) => {
    const formatVariant: NumberFormat = format ? formats.phone[format].format : "E.164";

    try {
      const isHomeCountryNumber = parsePhoneNumber(value, country as CountryCode)?.country === country;
      const includePrefix = format && formats.phone[format].foreignNumberPrefix;

      if (formatVariant === "NATIONAL" && includePrefix && isHomeCountryNumber) {
        return parsePhoneNumber(value, country as CountryCode)?.format("INTERNATIONAL") ?? value;
      }
      return parsePhoneNumber(value, country as CountryCode)?.format(formatVariant) ?? value;
    } catch (e) {
      console.warn(`Failed parsing phone number ${value}`, e);
      return value;
    }
  };
};
